import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=77cf5a02&"
import script from "./Prompt.vue?vue&type=script&lang=ts&"
export * from "./Prompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports